import { Pipe, PipeTransform } from "@angular/core"
import { formatIntervalBetweenDates } from "../functions/generic-methods"
import { MaybeDate } from "../models/date-helpers.models";
import { getDate } from "../utils/typeconversions";
import { Maybe } from "purify-ts";


/**
 * Calcula e exibe em texto intervalo entre duas datas
 */
@Pipe({
    name: 'dateInterval'
  })
  export class DateIntervalPipe implements PipeTransform {
  
  
    transform(firstMb: MaybeDate, secondMb: MaybeDate )  {
        const firstDate = getDate(firstMb);
        const secondDate = getDate(secondMb);
        
        return Maybe
            .sequence([firstDate , secondDate])
            .mapOrDefault( ([a,b]) => formatIntervalBetweenDates(a,b), '--' )
        
        


    }
  
  }
  